import { IconDeviceDesktopAnalytics, IconShoppingCart, IconReceipt2, IconUsers, IconApi, IconSettings, IconShieldLock, IconAdjustments, IconClipboardList, IconTruckDelivery } from '@tabler/icons-react';

const smartLocker = {
  id: 'smart-locker',
  title: '',
  type: 'group',
  children: [
    {
      id: 'device',
      title: 'Device',
      type: 'collapse',
      icon: IconDeviceDesktopAnalytics,
      children: [
        { id: 'device-list', title: 'Device List', type: 'item', url: '/device/list' },
        { id: 'device-facilities', title: 'Facilities', type: 'item', url: '/device/facilities' },
        { id: 'device-zones', title: 'Zones', type: 'item', url: '/device/zones' },
        { id: 'device-box', title: 'Boxes', type: 'item', url: '/device/box' },
        { id: 'device-overdue', title: 'Overdue Time', type: 'item', url: '/device/overdue' },
        { id: 'device-pickup', title: 'Pickup Code', type: 'item', url: '/device/pickup' },
        { id: 'device-history', title: 'History Logs', type: 'item', url: '/device/history' },
        { id: 'device-sms', title: 'SMS Logs', type: 'item', url: '/device/sms' },
        { id: 'device-email', title: 'Email Logs', type: 'item', url: '/device/email' },
        { id: 'device-email-templates', title: 'Email Templates', type: 'item', url: '/device/email-templates' },
        { id: 'device-sms-templates', title: 'SMS Templates', type: 'item', url: '/device/sms-templates' },
        { id: 'device-notifications-matrix', title: 'Notification Matrix', type: 'item', url: '/device/notifications-matrix' }
      ]
    },
    {
      id: 'order',
      title: 'Order',
      type: 'collapse',
      icon: IconShoppingCart,
      children: [
        { id: 'order-dispatch-monitor', title: 'Dispatch Monitor', type: 'item', url: '/order/dispatch-monitor' },
        { id: 'order-delivery', title: 'Awaiting Dropoff', type: 'item', url: '/order/delivery' },
        { id: 'order-pickup', title: 'Awaiting Pickup', type: 'item', url: '/order/pickup' },
        { id: 'order-delivered', title: 'Delivered', type: 'item', url: '/order/delivered' },
        { id: 'order-overdue', title: 'Overdue', type: 'item', url: '/order/overdue' }
      ]
    },
    {
      id: 'logistics',
      title: 'Logistics',
      type: 'collapse',
      icon: IconTruckDelivery,
      children: [
        { id: 'logistics-hubs', title: 'Hubs', type: 'item', url: '/logistics/hubs' },
        { id: 'logistics-vehicles', title: 'Fleet', type: 'item', url: '/logistics/vehicles' },
        { id: 'logistics-trips', title: 'Trips', type: 'item', url: '/logistics/trips' }
      ]
    },
    {
      id: 'payment',
      title: 'Payment',
      type: 'collapse',
      icon: IconReceipt2,
      children: [
        { id: 'payment-delivery', title: 'Delivery Rates', type: 'item', url: '/payment/delivery' },
        { id: 'payment-pickup', title: 'Pickup Rates', type: 'item', url: '/payment/pickup' },
        { id: 'payment-scheduled', title: 'Scheduled Rates', type: 'item', url: '/payment/scheduled' },
        { id: 'payment-additional', title: 'Additional Payments', type: 'item', url: '/payment/additional' },
        { id: 'payment-delivery-order', title: 'Delivery Payments', type: 'item', url: '/payment/delivery-order' },
        { id: 'payment-pickup-order', title: 'Pickup Payments', type: 'item', url: '/payment/pickup-order' }
      ]
    },
    {
      id: 'user',
      title: 'User',
      type: 'collapse',
      icon: IconUsers,
      children: [
        { id: 'user-manager', title: 'Managers', type: 'item', url: '/users/manager' },
        { id: 'user-courier-orgs', title: 'Courier Orgs', type: 'item', url: '/users/courier-orgs' },
        { id: 'user-employee', title: 'Couriers', type: 'item', url: '/users/employee' },
        { id: 'user-customer', title: 'Customer', type: 'item', url: '/users/customer' },
        { id: 'user-bind', title: 'Bind Device', type: 'item', url: '/users/bind' }
      ]
    },
    {
      id: 'api',
      title: 'Api',
      type: 'collapse',
      icon: IconApi,
      children: [
        { id: 'api-key', title: 'API KEY', type: 'item', url: '/api/key' },
        { id: 'api-device', title: 'API Device', type: 'item', url: '/api/device' },
        { id: 'api-interface', title: 'API Interface', type: 'item', url: '/api/interface' }
      ]
    },
    {
      id: 'client-settings',
      title: 'Client Settings',
      type: 'collapse',
      icon: IconSettings,
      children: [
        { id: 'client-main', title: 'Client', type: 'item', url: '/client/main' },
        { id: 'client-version', title: 'Version Control', type: 'item', url: '/client/version' }
      ]
    },
    { id: 'system-configs', title: 'System Configs', type: 'item', url: '/system-configs', icon: IconAdjustments },
    {
      id: 'security-group',
      title: 'Security & Access',
      type: 'collapse',
      icon: IconShieldLock,
      children: [
        { id: 'security-governance', title: 'Access Control', type: 'item', url: '/security/access-governance' },
        { id: 'security-mfa', title: 'Authentication & 2FA', type: 'item', url: '/security' }
      ]
    },
    { id: 'audit-logs', title: 'Audit Logs', type: 'item', url: '/system/audit-logs', icon: IconClipboardList }
  ]
};

export default smartLocker;
